import Buttons from './modules/buttons.js';
import Watcher from './modules/watcher.js';

var isTouch = false;
if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) { 
  isTouch = true;
  $('body').addClass('touch-device');
}

var buildSlider = function($slider) {
  $slider.each(function(index, elm) {
    var slider = $(elm);
    slider.find('.slide').addClass('swiper-slide');
    slider.addClass('swiper-wrapper');
    slider.wrap('<div class="swiper-container ' + $slider.attr('data-slider') +'"></div>');
    $('<div class="swiper-pagination"></div>').insertAfter(slider)
    $('<div class="swiper-button-prev"></div><div class="swiper-button-next"></div>').insertAfter(slider)
  });
};

var destroySlider = function($slider) {
  var $container = $slider.parent(),
    $duplicate = $container.find('[class*="swiper-slide-duplicate"]'); 

  $container.find('.swiper-button-prev').remove();
  $container.find('.swiper-button-next').remove();
  $container.find('.swiper-pagination').remove();
  $container.find('.swiper-slide-duplicate').remove();
  $container.find('.swiper-slide').removeClass('swiper-slide');
  $duplicate.removeClass('swiper-slide-duplicate-prev');
  $duplicate.removeClass('swiper-slide-duplicate-next');
  $container.find('.swiper-wrapper').removeClass('swiper-wrapper');
  $slider.unwrap();
};

var buttons = new Buttons({
  selectors: ['.button-primary', '.newsletter-toggle'],
  onlyOneActive: true
});

$('body').on('click.primaryClose', function(event) {
  if( $('html').hasClass('button-primary-active')) {
    var $target = $(event.target); 
    if($target.closest('.primary-wrapper').length < 1 && $target.closest('.toggle-container').length < 1) {
      $('.button-primary').trigger('click');
    }  
  }
});

var sliderOptions = {
  speed: 400,
  pagination: '.swiper-pagination',
  resistanceRatio: 0,
  prevButton: '.swiper-button-prev',
  nextButton: '.swiper-button-next'
  //loop: true
};

buildSlider($('[data-slider="slider"]'));
var mySlider = new Swiper('.swiper-container', sliderOptions); 

var introslider = function() {
  var $slider = $('#intro-slider'),
      timeout;

  var setPaginationPosition = function() {
    var images = $slider.find('.swiper-slide').first().find('img'),
        imgHeight;

    images.each(function(index, elm) {
      if ($(elm).is(':visible')) { imgHeight = $(elm).height(); } 
    });

    $slider.parent().find('.swiper-pagination').css({
      top: imgHeight - 50
    });
  };
  setPaginationPosition();

  $(window).on('load', function() {
    setPaginationPosition();
  });

  $(window).on('resize', function() {
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      setPaginationPosition();
    }, 20);
  });

}();

var mobileSlider = function() {
  var $slider = $('[data-slider="slider_m"]'),
      sliderOnPage = $slider.length > 0 ? true : false,
      mobileSwiper;

  var match = function() {
    // Destroy mobileSlider
    if (sliderOnPage && mobileSwiper) {
      mobileSwiper.destroy(true, true);
      destroySlider($slider);
    }

  },
  dismatch = function() {
    if (sliderOnPage) {
      // Build mobileSlider
      buildSlider($slider);
      mobileSwiper = new Swiper('.slider_m', sliderOptions); 
    }
  
  },
  
  query = new Watcher({
    breakpoint: 768, 
    match: match, 
    dismatch: dismatch
  });
  

}();


var reveal = function() {
  $('.reveal-onload').addClass('revealed');
  
  var $reveal = $('.reveal'),
      $body = $('body'),
      timeout;

  $reveal.each(function(inde,elm) {
    var $elm = $(elm);
    var waypoint = new Waypoint({
      element: $elm,
      handler: function(direction) {
        var $thisElm = $(this.element);
        if (!$thisElm.data('isRevealed')) {
          $thisElm.addClass('revealed').data('isRevealed', true);  
        }

        $(document).trigger('waypoint', [direction, $thisElm]);

      },
       offset: '65%'
    });

  });

  $(window).on('resize', function() {
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      Waypoint.refreshAll()
    }, 20);
  });
 
}();

var ajaxLoad = function() {
  var $ajax = $('.ajax-load');
  $ajax.each(function(index, elm) {
    var $elm = $(elm);
    $elm.attr('src', $elm.attr('data-src')); 
  });

}();


var checkScrollPos = function() {
  var query = location.search; 
  if (location.search) {
    var hash = query.substr( (query.indexOf('c=') + 2) , query.length ),
        hashArray = hash.split('&'),
        hashSection = hashArray[0],
        index = $('#' + hashSection).index();
    $('.subpage-menu li').eq(index).find('a').trigger('click');
  }
};


var subPage = function() {
  var $body = $('body')
 
  if (!$body.hasClass('subpage')) { return; }

  var isMobile,
      timeOut,
      orientation,
      counter = 0,
      $hero = $('#my-hero');

  var $mainArticle = $('.main-article'),
      $firstWrapper = $mainArticle.eq(0).find('> .wrapper'),
      $subSection = $('.subpage-section');

  var checkOrientation = function() {
    if ($(window).width() >  $(window).height()) {
      orientation = 'landscape'; 
    } else {
      orientation = 'portrait';
    }
  };

  var handleSubpageWaypoints = function(direction, element) {
    var $parent = element.parent(),
        index = $parent.index(),
        oldHash = $parent.prev().attr('id'),
        newHash = $parent.attr('id');

    var query = location.search,
        hash = query.substr( (query.indexOf('c=') + 2) , query.length ),
        hashArray = hash.split('&');

    if(direction == 'down') {
      $body.attr('data-subactive', (index + 1));
      
      if (history.replaceState) {
        $(hashArray).each(function(index, elm) {
          if(index !== 0) {
            newHash += '&' + elm;
          }
        });
        history.replaceState(null, null, '?c=' + newHash);
      } 

    } else {
      $body.attr('data-subactive', index );
      
      if ((index + 1) == 2) {
        $body.removeAttr('data-subactive');
      }

      if (history.replaceState) {
          $(hashArray).each(function(index, elm) {
            if(index !== 0) {
              oldHash += '&' + elm;  
            }
          });
      
        if(index === 1 && hashArray.length === 1) {
          history.replaceState(null, null, location.href.split("?")[0]); 
        } else {
          history.replaceState(null, null, '?c=' + oldHash);
        }

      }
    } 

  };
  
  $(document).on('waypoint', function(event, direction, index) {
    handleSubpageWaypoints(direction, index);
  });

  var setHeightsOfSubpages = function() {
    $mainArticle.each(function(index,sel) {
      var $sel = $(sel),
          windowHeight= $(window).height(),
          oldArticleHeight,
          articleHeight,
          topPos;
      
      $sel.removeAttr('style');
      oldArticleHeight = $sel.outerHeight();
      
      if (isMobile) {
        if (index === 0) {
          topPos = $sel.offset().top;
          articleHeight = windowHeight - Math.round(topPos);
        } else {
          articleHeight = windowHeight - Math.round($hero.outerHeight())
        }

      } else {
        if (index === 0) {
          articleHeight = windowHeight - Math.round($('.subpage-menu').outerHeight());
        } else {
          articleHeight = windowHeight;
        }
      }

      if (articleHeight > oldArticleHeight) {
        $sel.css({ height: articleHeight });  
      }
      
    });
  };

  var match = function() {
    counter += 1;
    isMobile = false;
    $(document).scrollTop(0);
    $body.removeAttr('data-subactive').removeClass('sticky-hero');
    $firstWrapper.removeAttr('style');
  },
  dismatch = function() {
    counter += 1;    
    isMobile = true;
    $(document).scrollTop(0);
    $body.removeAttr('data-subactive');
  },
  query = new Watcher({
    breakpoint: 1024, 
    match: match, 
    dismatch: dismatch
  });

  setHeightsOfSubpages();

  var subPageMenu = function() {
    var $link = $('.subpage-menu a');
    $link.on('click', function(event) {
      event.preventDefault();
 
      var $thisLink = $(event.target),
          target = $thisLink.attr('href'),
          targetId = target.substr(1, target.length),
          topPos  = $(target).offset().top;
      
      if (isMobile) {
        topPos  -= $hero.outerHeight()
      }

      $('html,body').animate({
        scrollTop: Math.round(topPos)
      });

    });

  };

  subPageMenu();
  checkScrollPos();

  $(window).on('resize', function() {
    if(!isTouch) {
      $(document).scrollTop(0); 
      $body.removeAttr('data-subactive'); 
      history.replaceState(null, null, location.href.split("?")[0]); 
    }
    clearTimeout(timeOut);
    timeOut = setTimeout(function() {

      if (counter >= 2 && isMobile) {
        location.reload();
      }

      setHeightsOfSubpages();
      Waypoint.refreshAll();
    },50);
  });

  $body.addClass('subpage-ready');

}();

var collapse = function() {
  $('.collapse').on('click', function(event) {
    event.preventDefault();
    $(event.target).toggleClass('expanded');
    return false;
  });

}();


var wallsScroll = function() {
  var $window = $(window),
      timeout,
      postsAvailable = true;

  if (!$('body').hasClass('walls')) { return; }
  $(document).on("WallsioNoMorePosts", function() {
    postsAvailable = false;
  });

  $window.on('scroll.walls',function() {
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      if ( ($window.scrollTop() + 400) >= ($(document).height() - $window.height()) ) {
        if (postsAvailable) {
          Wallsio.loadMorePosts(4);  
        }
      }
    }, 100);
  });

}();



// WEBPACK FOOTER //
// ./prod/layout/js/main.js